import { render, staticRenderFns } from "./standard.vue?vue&type=template&id=3c2c9f45&scoped=true"
var script = {}
import style0 from "./standard.vue?vue&type=style&index=0&id=3c2c9f45&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2c9f45",
  null
  
)

export default component.exports